/** The browser's local storage, or none where reading it throws. */
export function localStore(): Storage | undefined {
    try {
        return window.localStorage;
    } catch {
        return undefined;
    }
}

/** A window too narrow for the drawer beside the list, or a touch screen at any width. */
export const MOBILE = "(max-width: 1023px), (pointer: coarse)";

/** Whether there is a drawer beside the list at all: a desktop's, never on mobile. */
export function drawerBeside(): boolean {
    return !(typeof window.matchMedia === "function" && window.matchMedia(MOBILE).matches);
}
